import { Typography } from '@material-ui/core';
import _isEmpty from 'lodash/isEmpty';
import { PermissionActionsNames, PermissionActionsValues } from '@constants/permissions';
import { PermissionActions } from '@enums';
import { FeaturePermissionEntityInterface } from '@types';

interface Props {
  feature: FeaturePermissionEntityInterface;
  actionsOnly?: boolean;
}

export const FeaturePermissionItem = ({ feature, actionsOnly = false }: Props) => {
  const availableFields = Object.values(PermissionActions).filter((key) => feature[key] !== null);

  return (
    !_isEmpty(availableFields) && (
      <div className={actionsOnly ? '' : 'feature-item'} data-testid="dt-feature-permission">
        {!actionsOnly && (
          <>
            <Typography className="feature-item__name">{feature?.title || feature.name}</Typography>
            <Typography className="feature-item__description">
              {feature?.description || ''}
            </Typography>
          </>
        )}
        <div className="feature-item__list">
          {availableFields.map((key) => (
            <div className="feature-item__list feature-row" key={`${feature.name}-${key}`}>
              <Typography className="feature-row__header">{`${PermissionActionsNames[key]}:`}</Typography>
              <Typography>{`${PermissionActionsValues[`${feature[key]}`]}`}</Typography>
            </div>
          ))}
        </div>
      </div>
    )
  );
};
